export type Brand<K, T> = K & { __brand: T };
export type UTCMillis = Brand<number, "UTCMillis">;

export function dateToUTCMillis(date: Date): UTCMillis {
  return date.getTime() as UTCMillis;
}
